// table name in supabase
export const tableName = "vehicle_data_11_14_2024";
